(function ($) {

    function show_more_linked_products() {
        $('.linked-products__item.-show-more').click(function(){
          $(this).removeClass('-show-more');
        })
    }

    $(document).gp_ready(show_more_linked_products)

})(jQuery);